import { useSupportsHover } from './useSupportsHover';

/**
 * True on touch-first clients (phones/tablets — both the Capacitor native app
 * webview and mobile web) and false on desktop browsers driven by a
 * hover-capable pointer.
 *
 * Built on the same `(hover: hover)` media query as useSupportsHover so the
 * mobile/desktop split stays consistent across the app: a hover-capable
 * primary pointer ⇒ desktop; everything else ⇒ mobile. A touchscreen laptop
 * still reports `hover: hover` for its trackpad/mouse, so it is correctly
 * treated as desktop.
 *
 * Used to gate desktop-only features such as the multi-table grid view, which
 * must not appear on mobile (single active table only — switch via the table
 * fan or swipe navigation).
 */
export function useIsMobile(): boolean {
  return !useSupportsHover();
}
